// removed by extract-text-webpack-plugin
module.exports = {"descriptionList":"antd-pro-description-list-descriptionList","title":"antd-pro-description-list-title","term":"antd-pro-description-list-term","detail":"antd-pro-description-list-detail","small":"antd-pro-description-list-small","large":"antd-pro-description-list-large","vertical":"antd-pro-description-list-vertical"};


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/src/components/DescriptionList/index.less
// module id = 344
// module chunks = 0